import React, { useState } from "react";
import { DailyIcon } from "@/features/daily/components/DailyIcon";
import { HealthCauses } from "@/features/daily/components/command/HealthCauses";
import { ServicesStrip } from "@/features/daily/components/command/ServicesStrip";
import type { ServiceVm, StatusStripVm } from "@/features/daily/components/command/health-view-model";

const PANEL_ID = "daily-cc-strip-causes";

type Props = {
    strip: StatusStripVm;
    services: ServiceVm[];
};

export const StatusStrip: React.FC<Props> = ({ strip, services }) => {
    const [open, setOpen] = useState(false);
    return (
        <section className="daily-cc-strip" data-tone={strip.tone} aria-label="Comprobaciones en vivo">
            <div className="daily-cc-strip__line" role="status">
                <DailyIcon name={strip.icon} />
                {strip.severityLabel === null ? null : <span className="daily-cc-strip__severity">{strip.severityLabel}</span>}
                <span className="daily-cc-strip__title">{strip.title}</span>
                {strip.detail === null ? null : <span className="daily-cc-strip__detail">{strip.detail}</span>}
            </div>
            <ServicesStrip services={services} />
            {strip.causes === null ? null : (
                <button
                    type="button"
                    className="daily-cc-strip__toggle"
                    aria-expanded={open}
                    aria-controls={PANEL_ID}
                    onClick={() => setOpen((value) => !value)}
                >
                    {open ? "Ocultar causas" : "Ver causas y cómo normalizar"}
                </button>
            )}
            {strip.causes === null ? null : (
                <div className="daily-cc-strip__panel" id={PANEL_ID} hidden={!open}>
                    <HealthCauses causes={strip.causes} />
                </div>
            )}
        </section>
    );
};
